import styled from 'styled-components';
import { IWrapper } from './interface';

const defaultComponent = styled.div<IWrapper>`
  display: ${(props) => {
    if (props.isActive) {
      if (props.display) {
        return props.display;
      }
      return 'flex';
    }
    return 'none';
  }};
  grid-area: ${(props) => (props.gridArea ? props.gridArea : 'none')};
  flex-direction: ${(props) =>
    props.flexDirection ? props.flexDirection : 'column'};
  justify-content: ${(props) =>
    props.justifyContent ? props.justifyContent : 'center'};
  align-items: ${(props) => (props.alignItens ? props.alignItens : 'center')};
  row-gap: ${(props) => (props.rowGap ? props.rowGap : 'none')};
  column-gap: ${(props) => (props.columnGap ? props.columnGap : 'none')};
  width: ${(props) => (props.width ? props.width : 'auto')};
  max-width: ${(props) => (props.maxWidth ? props.maxWidth : '100%')};
  height: ${(props) => (props.heigth ? props.heigth : 'auto')};
  padding: ${(props) => (props.padding ? props.padding : 0)};
  margin: ${(props) => (props.margin ? props.margin : 0)};
  color: ${(props) => (props.color ? props.color : 'none')};
  border-radius: ${(props) =>
    props.borderRadius ? props.borderRadius : 'none'};
  background-color: ${(props) =>
    props.backgroundColor ? props.backgroundColor : 'transparent'};

  overflow-y: ${(props) => (props.scrollY ? 'scroll' : 'none')};
  overflow-x: ${(props) => (props.scrollX ? 'scroll' : 'none')};

  &:hover {
    cursor: ${(props) => (props.showPointer ? 'pointer' : 'auto')};
  }
`;
const buttons = styled.div`
  display: flex;
  flex-direction: row;
`;
const button = styled.button`
  background: #ffffff;
  border: 2px solid #125c5b;
  border-radius: 10px;
  font-style: normal;
  font-weight: 700;
  font-size: 1rem;
  line-height: 16px;
  text-align: center;
  color: #125c5b;
  padding: 10px 40px;
  min-width: 61px;
  height: auto;
  min-width: 61px;
`;

const LabelSpan = styled.label`
  font-style: normal;
  font-weight: 600;
  font-size: 1.1rem;
  line-height: 24px;
  display: flex;
  margin: 0;
  padding-left: 5px;
  align-items: center;
  text-align: center;
  color: #606060;
`;

const Wrapper = {
  Default: defaultComponent,
  Buttons: buttons,
  Button: button,
  Label: LabelSpan,
};

export default Wrapper;
